module.exports = __webpack_public_path__ + "img/GH-kyujin-top-018.130f90b7.webp";